import styled, { css } from 'styled-components';
import { black, grey500 } from 'styles/colors';
import { ApSelect, colors } from '@alixpartners/ui-components';

export const MetadataSummaryLine = styled.tr``;

export const SummaryLabel = styled.td`
	color: ${grey500};
	font-size: 16px;
	line-height: 32px;
	font-weight: normal;
	padding: 12px 64px 12px 12px;
`;

export const SummaryValue = styled.td`
	color: ${black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
`;

export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 177px;
	margin-bottom: 19px;
	padding-right: 32px;
`;

export const Line = styled.hr`
	margin: 1% 0 2% 0;
	border: 0;
	height: 1px;
	background-color: ${colors.grey300}
`;

export const SelectWrapper = styled.div`
	label {
		display: none;
	}
	& span {
		line-height: 24px;
		border-color: ${colors.grey4};
	}
`;

export const Select = styled(ApSelect)`
	width: 384px;
	min-width: 384px !important;
	${({ small }) =>
		small && css`
			max-width: 175px !important;
			min-width: 175px !important;
		`
	}
`;

export const EditAliasActions = styled.div`
	width: 100%;
	display: flex;
	padding: 3% 0 0 0;
`;